import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const ControllerIcon = ({ size, color = '#B8BECC', deg, e2eId, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg, "data-e2e-id": e2eId },
    React.createElement("path", { fill: color, fillRule: "evenodd", d: "M10 8l4 4H6z" })));
export const Controller = iconGenerator(ControllerIcon);
//# sourceMappingURL=Controller.js.map